import api from './api';

const customerProfileService = {
    /**
     * Get customer profile
     */
    async getProfile() {
        try {
            const response = await api.get('/customer/profile');
            return response.data;
        } catch (error) {
            console.error('Error fetching customer profile:', error);
            throw error;
        }
    },

    /**
     * Change customer password
     */
    async changePassword(passwordData) {
        try {
            const response = await api.post('/customer/change-password', passwordData);
            return response.data;
        } catch (error) {
            console.error('Error changing password:', error);
            throw error;
        }
    }
};

export default customerProfileService;
